import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  openBlockedItemToast: ['data'],
  closeBlockedItemToast: []
});

const INITIAL_STATE: any = {
  additionalInformation: undefined,
  text:'',
  text2: '',
  buttonLabel: '',
  actionButton: undefined,
  buttonActionLabel: undefined
};

const openBlockedItemToast = (_state = INITIAL_STATE, action: any) => ({
  ...action.data, show: true
});


const closeBlockedItemToast = (state = INITIAL_STATE, _action: any) => ({
  ...state, show: false
});

export default createReducer(INITIAL_STATE, {
  [Types.OPEN_BLOCKED_ITEM_TOAST as any]: openBlockedItemToast,
  [Types.CLOSE_BLOCKED_ITEM_TOAST as any]: closeBlockedItemToast
});